{
	"title": "Garantizar la rendición de cuentas mediante la instalación de un banco de carbono",
	"description": "Heidelberg Materials ha tomado medidas exhaustivas para garantizar la credibilidad de las reducciones de carbono generadas por nuestra planta de cemento CCS. Para evitar cualquier posibilidad de doble contabilidad, hemos implementado un banco de carbono virtual seguro en un libro de contabilidad público distribuido.",
	"traceabilityTitle": "Trazabilidad de las reducciones de carbono"
}
